// @ts-nocheck

/* eslint-disable no-undef */

/* eslint-disable arrow-body-style */
import * as hosts from './hostLocations';

export function fetchUserEvents(idToUse: any, callback: any) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/event/fetchUserEvents';

    const data = {
      userId: idToUse,
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };

    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(events => {
        if (callback) {
          callback(events);
        }
      })
      .catch(error => {
        alert('There was an error with your request.');
        throw error;
      });
  };
}

export function fetchAppEvents(idToUse: any, callback: any) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/event/fetchEventsByApp';

    const data = {
      appId: idToUse,
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };

    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(events => {
        if (callback) {
          callback(events);
        }
      })
      .catch(error => {
        alert('There was an error with your request.');
        throw error;
      });
  };
}

export function fetchLatestEvents(idToUse: any, timeStamp: any, callback: any) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/event/fetchLatestEvents';

    const data = {
      userId: idToUse,
      timeStamp,
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };

    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(events => {
        if (callback) {
          callback(events);
        }
      })
      .catch(error => {
        alert('There was an error with your request.');
        throw error;
      });
  };
}
